import { ApplicationState } from "../..";
import { ServerResponseBase } from "../../interfaces";
import { format } from "date-fns";
import { toErrorPayload } from "../../../helpers/errorPayload";
import { SERVER_ERROR_MESSAGE, API_HOST_ERROR_MESSAGE } from "../../../constants/errorMessages";
import { setServerError } from "../../error";

const method = "POST";
const headers = { "Content-Type": "application/json" };

export interface PurchaseResponse extends ServerResponseBase {
  IsSuccess?: boolean;
  signingService: {
    signingService?: boolean;
    signingServiceUrl?: string;
  };
}

const Purchase = async (state: ApplicationState, dispatch?: Function): Promise<PurchaseResponse> => {
  if (!state.inputs.apiHost) {
    if (dispatch) dispatch(setServerError(API_HOST_ERROR_MESSAGE, SERVER_ERROR_MESSAGE));
    throw toErrorPayload({ message: API_HOST_ERROR_MESSAGE, header: SERVER_ERROR_MESSAGE });
  }

  const url = `${state.inputs.apiHost}/api/se/purchase`;

  let startDate = state.insurance?.startDate?.value ? format(state.insurance.startDate.value, "yyyy-MM-dd") : null;

  if (state.inputs.brand.toLocaleLowerCase() === "polestarforetag" && state.profile?.isCarNew) {
    startDate = "9999-09-09";
  }

  const data = {
    quoteId: state.inputs.quoteId,
    startDate: startDate ?? undefined,
    policyHolderContactInformation: {
      email: state.profile?.email?.value ?? "",
      mobilePhoneNumber: state.profile?.phone?.value ?? "",
    },
    paymentInformation: {
      bankAccountNumber: state.payment?.inputs.bankAccountNumber.value ?? "",
      bankClearingNumber: state.payment?.inputs.bankAccountClearingNumber.value ?? "",
    },
    selectedPaymentFrequencyAndMethodId: state.payment?.selectedPaymentTypeCode,
  };

  const response = await fetch(`${url}`, {
    method,
    mode: "cors",
    headers,
    body: JSON.stringify(data),
  });

  const json = await response.json();

  if (response.status !== 200 || json.status === "Error") {
    const message = (json && json.dealerPurchaseMessage) || (json && json.message) || SERVER_ERROR_MESSAGE;
    if (dispatch) dispatch(setServerError(message, SERVER_ERROR_MESSAGE));
    throw toErrorPayload({ message, header: SERVER_ERROR_MESSAGE });
  }

  sessionStorage.removeItem("store");

  return {
    IsSuccess: json.Status === 0,
  } as PurchaseResponse;
};

export default Purchase;
